
class PaymentInstallmentTemplateDetailViewController extends MUIViewController
{
    static newInstance() : PaymentInstallmentTemplateDetailViewController {
        let vc = new PaymentInstallmentTemplateDetailViewController("payment-installment-template-detail-view");
        vc.initWithResource("layout/installment_templates/PaymentInstallmentTemplateDetailView.html");
        return vc;
    }

    private backButton:MUIButton = null;
    private addButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private nameTextField:MUITextField = null;
    private totalPercentageLabel:MUILabel = null;
    private tableView:UITableView = null;

    private nf = MUIWebApplication.sharedInstance().delegate.numberFormatter as MIONumberFormatter;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function(){
            this.navigationController.popViewController();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addLineAction);

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, this.saveAction);

        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnChangeText(this, function(this:PaymentInstallmentTemplateDetailViewController, textField:MUITextField, value:string){
            this.template.name = value;
        });

        this.totalPercentageLabel = MUIOutlet(this, "total-percentage-lbl", "MUILabel");

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private template:PaymentInstallmentTemplate = null;
    set item(item:PaymentInstallmentTemplate){
        this.template = item;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this.template == null) return;

        this.nameTextField.text = this.template.name;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
        this.updateTotalPercentage();
    }

    private updateTotalPercentage(){
        let total = 0;
        for (let line of this.template.lines.allObjects as PaymentInstallmentTemplateLine[]) {
            if (line.deletedAt != null) continue;
            total += line.percentage;
        }

        this.totalPercentageLabel.text = this.nf.stringFromNumber(total) + " %";
        MUICoreLayerRemoveStyle(this.totalPercentageLabel.layer, "alert");
        if (total != 100) MUICoreLayerAddStyle(this.totalPercentageLabel.layer, "alert");
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("PaymentInstallmentTemplateLineCell") as PaymentInstallmentTemplateLineCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentInstallmentTemplateLine;
        cell.item = item;

        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentInstallmentTemplateLine;

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let predicateFormat = 'template.identifier == "' + this.template.identifier + '"';

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("orderIndex", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("PaymentInstallmentTemplateLine", sortDescriptors, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["template"];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
        this.updateTotalPercentage();
    }

    private addLineAction(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_PAYMENT", "NEW PAYMENT"), MIOLocalizeString("DAYS_AND_PERCENTAGE", "DAYS AND PERCENTAGE"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("DAYS", "DAYS"));
        });

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("PERCENTAGE", "PERCENTAGE"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(this:PaymentInstallmentTemplateDetailViewController){
            let days = this.nf.numberFromString(avc.textFields[0].text.trim());
            let percentage = this.nf.numberFromString(avc.textFields[1].text.trim());

            this.createLine(days != null ? days : 0, percentage != null ? percentage : 0);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private createLine(days:number, percentage:number){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let orderIndex = 0;
        for (let line of this.template.lines.allObjects as PaymentInstallmentTemplateLine[]) {
            if (line.orderIndex > orderIndex) orderIndex = line.orderIndex;
        }

        let line = MIOEntityDescription.insertNewObjectForEntityForName("PaymentInstallmentTemplateLine", ad.managedObjectContext) as PaymentInstallmentTemplateLine;
        line.offsetDays = days;
        line.percentage = percentage;
        line.orderIndex = orderIndex + 1;
        line.template = this.template;

        ad.managedObjectContext.save();
    }

    private saveAction(){
        DBHelper.saveMainContext();
        this.updateTotalPercentage();
    }
}
